

export const getRouteData = () => {

    const url = "https://soappenterprise.com"
    // const url = "http://localhost:8080"

    const routes = {
        create_payment_intent: "/create-payment-intent",
        send_email: "/send-email",
        update_donation: "/update-donation",
        delete_doodle: "/delete-doodle",
        save_donation: "/save-donation",
    }

    const stripe_key = "pk_live_51PbijrRqCrMKUIvGVYCirRN8SL2FPsjmKPbE35IVz9JkqoOzIwHlnEDcpZUVqUymEj2z57XCzYh1cVhIVOhC2jp500cErT5jvP"
    // const stripe_key = "pk_test_51PbijrRqCrMKUIvGtsRTv1XNM5N0uxw0sGDhCSRUvfSUdZmcZBSX06tcaqSp60OYUTOMVfmi4vFMZdwJVtXFFIUA00SB2KMjyB"

    return {
        url,
        routes,
        stripe_key,
    }
}